module.exports = __webpack_public_path__ + "static/kaneshin0120-dd4e503839c9c635fff6d9f06a3364ee.jpg";